module.exports = __webpack_public_path__ + "img/installations OneB Mapper_2.2e40b1c7.jpg";